var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgScrollArrowIcon = function SvgScrollArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.065 25.935a1.494 1.494 0 0 1-2.115 0L7.065 16.05a1.494 1.494 0 0 1 0-2.115l9.87-9.87a1.494 1.494 0 0 1 2.115 0c.6.585.6 1.53.015 2.115L10.245 15l8.82 8.82c.585.585.585 1.53 0 2.115z"
  })));
};

export default SvgScrollArrowIcon;